import React from 'react'

import PropTypes from 'prop-types'

import './coupon-welfare.css'

const CouponWelfare = (props) => {
  return (
    <div className={`coupon-welfare-container ${props.rootClassName} `}>
      <div className="coupon-welfare-coupon-welfare-container">
        <div className="coupon-welfare-frame5024">
          <div className="coupon-welfare-frame5022">
            <div className="coupon-welfare-frame5021">
              <div className="coupon-welfare-frame5020">
                <span className="coupon-welfare-text">
                  <span className="">Amazon - Buoni Regalo</span>
                </span>
                <span className="coupon-welfare-text02">
                  {/* <span className="">€26,60</span> */}
                </span>
              </div>
              <span className="coupon-welfare-text04">
                <span className="">
                  <span className="">
                  Scopri i Buoni regalo, disponibili per e-mail o tramite SMS, da stampare oppure inviali per posta—o ricarica il tuo saldo buoni regalo utilizzando Amazon Ricarica.
                  </span>
                  <br className=""></br>
                  {/* <span className="">266 caratteri</span> */}
                </span>
              </span>
            </div>
            <div className="coupon-welfare-frame5008">
              <div className="coupon-welfare-frame5030">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/d/de/Amazon_icon.png"
                  alt="image95251"
                  className="coupon-welfare-image9"
                />
                <div className="coupon-welfare-frame5003">
                  <span className="coupon-welfare-text09">
                    <span className="">Shopping</span>
                  </span>
                </div>
                <div className="coupon-welfare-frame5004">
                  <span className="coupon-welfare-text11">
                    {/* <span className="">Scade il 26/06/22</span> */}
                  </span>
                </div>
              </div>
              <a target="_blank" href='https://amzn.to/3FuSfvE'>
              <div className="coupon-welfare-frame13">
                <span className="coupon-welfare-text13">
                  <span className="">Scopri i dettagli</span>
                </span>
                <img
                  src="/playground_assets/vector24951-98.svg"
                  alt="Vector24951"
                  className="coupon-welfare-vector2"
                />
              </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CouponWelfare.defaultProps = {
  rootClassName: '',
}

CouponWelfare.propTypes = {
  rootClassName: PropTypes.string,
}

export default CouponWelfare
